import { Switch, Route } from 'react-router-dom';
import { RevenueSharingForm } from './RevenueSharingForm/RevenueSharingForm';
import { RevenueSharingList } from './RevenueSharingList/RevenueSharingList';

export const RevenueSharings: React.FC = () => {

  const renderRevenueSharingList = () => {
    return <RevenueSharingList />;
  };

  const renderCreateRevenueSharingForm = () => {
    return <RevenueSharingForm />;
  };

  return (
    <Switch>
      <Route
        path={'/revenue-sharings/new'}
        render={renderCreateRevenueSharingForm}
      />
      <Route
        render={renderRevenueSharingList}
      />
    </Switch>
  );
};
